import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import * as yup from "yup";

import * as RHFAddressValidationRules from "@/utils/validation/schemas/address.RHF";

export const BPostAddressValidationSchema = yup.object({
    address: RHFAddressValidationRules.addressLine
});

export type BPostAddressFieldValues = yup.InferType<
    typeof BPostAddressValidationSchema
>;

export type BPostFieldAddress = CloudCustomerAddress & {
    address: string;
    selected: boolean;
    isComplete: boolean;
};
